import React from "react"
import moment from "moment"
import {useTranslation} from "react-i18next"

const icon = require("~/icons/stock_out_32_blue.svg")

const ListItemStockOut = ({article, user, created_at}) => {
  const {t} = useTranslation()
  const date = moment(created_at)

  const productName = article.name
  const userEmail = user.email

  return (
    <div className="sh-list-item">
      <img src={icon} alt={t("deliveryNotes.stockOut")} />
      <div className="content">
        <div className="primary">
          <div>{t("deliveryNotes.stockOut")}</div>
        </div>
        <div className="secondary">
          <div>
            {productName && (
              <span>
                {t("deliveryNotes.procuctName")}: «
                <strong>{productName}</strong>»
              </span>
            )}
            {userEmail && (
              <span>
                {t("deliveryNotes.user")}: «<strong>{userEmail}</strong>»
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="date">{date.format("D.M.YYYY – H:mm")}</div>
    </div>
  )
}

export default ListItemStockOut



// WEBPACK FOOTER //
// ./src/components/list_items/ListItemStockOut.js